import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs';
import { handleSortableUpdate } from './concerns/board'
import { AutoScroll } from "./concerns/auto_scroll"


// Connects to data-controller="assignment"
export default class extends Controller {
  connect() {
    const progressId = this.element.dataset.progressId || 'backlog'

    // Backlog以外（進捗ステータスあり）の場合はドラッグ不可
    if (progressId !== 'backlog') {
      return
    }

    const isMobile = this.#isMobileDevice()

    const options = {
      group: 'assignments_backlog',
      handle: ".drag_handle",
      animation: 150,
      delay: 300,
      delayOnTouchOnly: true,
      onStart: this.#onStart.bind(this),
      onEnd: this.#assigned.bind(this)
    }
    Sortable.create(this.element, options)

    // スマホ版ではSwiperBoardControllerがスクロールを管理するためAutoScrollは無効
    if (!isMobile) {
      Object.assign(this, AutoScroll)
      this.initAutoScroll('assignment_board')
    }
  }

  disconnect() {
    if (this.disconnectAutoScroll) {
      this.disconnectAutoScroll()
    }
  }

  #onStart() {
    // 触覚フィードバック（対応ブラウザのみ）
    navigator.vibrate?.(15)
  }

  #isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  }

  async #assigned(event) {
    await handleSortableUpdate(event)
  }
}